import React from 'react';
import NavBar from './navBar'
import pic3 from "../img/WhatsApp Image 2022-10-02 at 1.29.06 PM (1).jpeg"
import pic4 from "../img/WhatsApp Image 2022-10-02 at 1.29.06 PM.jpeg";
import pic5 from "../img/WhatsApp Image 2022-10-02 at 1.54.28 PM (1).jpeg";
import pic6 from "../img/WhatsApp Image 2022-10-02 at 1.54.28 PM.jpeg"

const Ml = () => {
    
    return(
        <div style={{height:"100vh"}}>
            <NavBar/>
            <h1>
                Machine Learning
            </h1>
            <h2>Time series</h2>
            <img src={pic3} style={{height:"400px"}}/>
            <img src={pic4} style={{height:"400px"}}/>

            <h2>Regression Model</h2>
            <img src={pic6} style={{height:"500px"}}/>
            <img src={pic5} style={{height:"100px"}}/>
        </div>
    )
}

export default Ml;